module.exports = __webpack_public_path__ + "74c650c0a61ac63129882a3de97b1221.svg";